import { Checkbox, CheckboxLabel } from '@cfs-fixings/shared'
import { useContext } from 'react'
import PanelInput from '../../properties/components/PanelInput'
import { LoadsContext } from '../hooks/LoadsContext'

// Defined by "EuroCode" and CFS team
export const safetyFactors = {
  permanent: 1.35,
  variableLoad: 1.5,
}

export enum LoadTypes {
  Design = 'design',
  Characteristic = 'characteristic',
}

const LoadTypeForm = () => {
  const { design, loadType, setLoadType } = useContext(LoadsContext)

  const handleLoadTypeChange = () => {
    const previousLoadType = loadType
    const newLoadType = previousLoadType === LoadTypes.Design
      ? LoadTypes.Characteristic
      : LoadTypes.Design

    if (!design) {
      return null
    }

    setLoadType?.(newLoadType)
  }

  return (
    <div className="flex flex-col gap-y-8">
      <div className="flex flex-col gap-y-4">
        <Checkbox
          variant="secondary"
          checked={loadType === LoadTypes.Design}
          onChange={handleLoadTypeChange}
        >
          <CheckboxLabel>
            Design Loads
          </CheckboxLabel>
        </Checkbox>
        <Checkbox
          variant="secondary"
          checked={loadType === LoadTypes.Characteristic}
          onChange={handleLoadTypeChange}
        >
          <CheckboxLabel>
            Characteristic Loads
          </CheckboxLabel>
        </Checkbox>
      </div>
      <SafetyFactorsSection
        isHidden={loadType === LoadTypes.Characteristic}
      />
    </div>
  )
}

// ---

type LoadTypeFormProps = {
  isHidden: boolean
}

const SafetyFactorsSection = ({ isHidden }: LoadTypeFormProps) => {
  if (!isHidden) {
    return null
  }

  return (
    <div className="flex flex-col gap-y-4">
      <h1 className="text-sm leading-[16.8px] font-semibold">
        Safety Factors
      </h1>
      <div className="flex flex-col gap-y-4">
        <PanelInput
          title="Permanent Loads"
          value={safetyFactors.permanent}
          type="number"
          disabled
        />
        <PanelInput
          title="Variable Loads"
          value={safetyFactors.variableLoad}
          type="number"
          disabled
        />
      </div>
    </div>
  )
}

// ---

export default LoadTypeForm
